module.exports = __webpack_public_path__ + "img/3.85016a8f.png";